var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.Estado == 'ok')?_c('div',[_c('p',{staticClass:"t-xx-normal fw-500"},[_vm._v("Respuestas")]),(_vm.Resultado.Respuestas.hasRows())?_c('div',_vm._l((_vm.Curso.Preguntas),function(item){return _c('div',[_c('pregunta',{attrs:{"Resultado":_vm.Resultado,"Pregunta":item}})],1)}),0):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }